import React from 'react';

// Base
import Carousel from '../../base/carousel';

export default class SidebarPitch extends React.Component {
  render() {
    return (
      <div className='max-width-400 margin-center margin-top-195'>
        <div className="lg-font line-height-24 tertiary-color vertical-align margin-bottom-30">What do you get with OompleAI</div>
        <Carousel height={350}>
          <div>
            <div className="xlg-font line-height-24 tertiary-color margin-bottom-30 med-bold">Experience the future of hiring</div>
            <div className="font-size-22 line-height-42 tertiariy-color">
              Oomple’s AI efficiently parses resumes and supports your candidate pipeline, streamlining recruitment and enhancing candidate quality.
            </div>
          </div>
          <div>
            <div className="xlg-font line-height-24 tertiary-color margin-bottom-30 med-bold">Discover the Future of Effortless Hiring</div>
            <div className="font-size-22 line-height-42 tertiariy-color">
              Oomple Copilot is the all-in-one hiring solution hiring solution, now upgraded with AI and real-time data, providing a groundbreaking platform for consultancies
            </div>
          </div>
        </Carousel>
      </div>
    )
  }
}
